export default {
  error_5: "Common error",
  error_no_permission: "No Permission",
  error_invalid_email: "Invalid email",
  error_invalid_phone: "Invalid phone number",
};
